module.exports = __webpack_public_path__ + "static/grunge-background-dark2-2a39ae7c835828725c68ba15853212be.png";